import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ErrorPage, PageBreadcrumbProps, PageLayout } from "../../";
import { UserService } from "../../../services";
import { generateUserBreadcrumbs, UserTopbar } from "./";
import { useAsync,
  PageTitleProvider,
  usePageTitle,
  useUrlParams } from "../../../hooks";
import { BreadcrumbProps } from "../../../components";


function BaseLayout() {
  const userService = new UserService();
  const id = parseInt(useUrlParams("id"));
  const { value: user, loading, error } = useAsync(() => userService.get(id), [id]);
  const [breadcrumbs, setBreadcrumbs] = useState<PageBreadcrumbProps>();
  const location = useLocation();
  const { title } = usePageTitle();

  /**
   * Initialize breadcrumbs for the page depending on the route
   */
  useEffect(() => {
    if(id) {
      const newBreadcrumbs:BreadcrumbProps = generateUserBreadcrumbs(location.pathname, user?.email ?? "", id);
      setBreadcrumbs(newBreadcrumbs);
    }
  }, [location.pathname, user])

  if(loading) return <></>
  if(error){
    return <ErrorPage message={error.message} />
  }
  return (
    <PageLayout title={`${title}`} topbar={<UserTopbar />} breadcrumbs={breadcrumbs}>
      <Outlet />
    </PageLayout>
  )
}

export function UserLayout() {
  // Wrap the BaseUserLayout in a PageTitleProvider.
  // This prevents an error of the context not being initialized when the usePageTitle hook is called.
  return (
    <PageTitleProvider>
      <BaseLayout />
    </PageTitleProvider>
  );
}

export default UserLayout
